/* 列傳的畫面：蹄印、驄馬、任務標記（view 在有 w.campaign.mission 時呼叫 SG.campaignDraw） */
// @ts-nocheck
import { SG } from '../core/sg.ts';

const missionOf = (view) => view.w.campaign && view.w.campaign.mission;

SG.campaignDraw = {
  // 地面：缺了橋板的橋、湍急的渡口、蹄印（兩個並排的小新月，越久越淡）
  ground(ctx, view, inView) {
    const m = missionOf(view);
    if (!m) return;
    if (m.def.ground) m.def.ground(ctx, m, view, inView); // 章節自己的地面（足跡、地上的圖）
    for (const g of m.gates) if (inView(g.x, g.y, g.r + 120)) { if (g.look === 'repair') brokenBridge(ctx, g, view.WS.time); else if (g.look === 'flood') flood(ctx, g, view.WS.time); }
    for (const c of m.burnt) { const x = ((c % 4096) + 0.5) * 80, y = (Math.floor(c / 4096) + 0.5) * 80; if (inView(x, y, 60)) { ctx.fillStyle = 'rgba(28,22,18,.45)'; ctx.beginPath(); ctx.ellipse(x, y, 52, 36, 0, 0, Math.PI * 2); ctx.fill(); } } // 焦土
    for (const c of m.fires.values()) if (c.water && inView(c.x, c.y, 70)) { // 漫上來的水：藍色的水面，越久越深
      const k = Math.min(1, c.age / 3), T = view.WS.time;
      ctx.fillStyle = c.mud ? `rgba(84,66,42,${(0.6 + 0.25 * k).toFixed(3)})` : `rgba(52,96,118,${(0.45 + 0.3 * k).toFixed(3)})`; ctx.fillRect(c.x - 41, c.y - 41, 82, 82); // mud：泥濘（棕色）
      ctx.strokeStyle = 'rgba(200,225,235,.25)'; ctx.lineWidth = 2; ctx.beginPath(); const o = ((T * 20 + c.i * 13) % 40) - 20; ctx.moveTo(c.x - 24 + o, c.y - 10); ctx.lineTo(c.x + o, c.y - 6); ctx.stroke();
    }
    for (const z of m.warns) warnDraw(ctx, z, view.WS.time);
    const ar = m.vars.duel && m.vars.arena;
    if (ar && inView(ar.x, ar.y, ar.r + 40)) arena(ctx, ar, view.WS.time);
    if (!m.prints.length) return;
    const T = view.w.t;
    ctx.save();
    for (const p of m.prints) {
      if (!inView(p.x, p.y, 40)) continue;
      const a = Math.max(0, 0.75 - (T - p.t) / 240);
      if (a <= 0) continue;
      ctx.fillStyle = `rgba(36,26,16,${a.toFixed(3)})`;
      for (const s of [-1, 1]) {
        const ox = Math.cos(p.a + Math.PI / 2) * 9 * s, oy = Math.sin(p.a + Math.PI / 2) * 9 * s * SG.K;
        ctx.beginPath(); ctx.ellipse(p.x + ox, p.y + oy, 7, 5, p.a, 0.4 * Math.PI, 1.6 * Math.PI); ctx.fill();
      }
    }
    ctx.restore();
  },
  // 依縱深排序的東西：修橋的工匠與告示、渡口的告示、驄馬
  ents(ctx, view, ents, inView) {
    const m = missionOf(view), T = view.WS.time;
    if (m) for (const g of m.gates) {
      if (!inView(g.x, g.y, g.r + 200)) continue;
      if (g.look === 'repair') {
        const c = Math.cos(g.a), s = Math.sin(g.a), at = (d, n) => [g.x + c * d - s * n, g.y + s * d + c * n * 0.7];
        [[-74, -78], [-74, 78], [74, -78], [74, 78]].forEach(([d, n]) => { const [x, y] = at(d, n); ents.push({ y, draw: () => pole(ctx, x, y) }); });
        { const [x, y] = at(-150, -70); ents.push({ y, draw: () => sign(ctx, x, y, '修橋中') }); }
        [[-104, -30, 0], [-112, 34, 1.7]].forEach(([d, n, ph]) => { const [x, y] = at(d, n); ents.push({ y, draw: () => worker(ctx, x, y, 1, T + ph) }); });
      } else if (g.look === 'flood') {
        const [x, y] = [g.x - 230, g.y - 40];
        if (inView(x, y, 80)) ents.push({ y, draw: () => sign(ctx, x, y, '水急勿渡') });
      }
    }
    if (m) for (const g of m.gates) if ((g.look === 'citygate' || g.look === 'abatis') && inView(g.x, g.y, g.r + 120)) ents.push({ y: g.y + 10, draw: () => (g.look === 'citygate' ? cityGate : abatis)(ctx, g, T) });
    if (m) for (const b of m.boats) if (inView(b.x, b.y, 200)) ents.push({ y: b.y - 1, draw: () => boatDraw(ctx, b, T) });
    if (m) for (const c of m.fires.values()) if (!c.water && inView(c.x, c.y, 80)) ents.push({ y: c.y + 20, draw: () => flame(ctx, c, T) });
    if (m) for (const f of m.folks) if (inView(f.x, f.y, 80)) ents.push({ y: f.y, draw: () => (f.lying ? lying(ctx, f, T) : f.draw ? f.draw(ctx, f, T) : villager(ctx, f, T)) });
    if (m) for (const l of m.loots) if (!l.got && inView(l.x, l.y, 60)) ents.push({ y: l.y, draw: () => lootDraw(ctx, l, T) });
    const h = m && m.vars.horse;
    if (!h || h.i >= h.path.length + 60 || !inView(h.x, h.y, 120)) return;
    ents.push({ y: h.y, draw: () => SG.drawHorse(ctx, h.x, h.y, h.f, h.i < h.path.length ? view.WS.time : 0, '#c9c6bc', '#6a4a30', 1) });
  },
  // 迷霧之上：任務標記（金色箭頭與名稱；畫面外就在邊緣畫一個指向的三角）
  over(ctx, view, x0, y0, vw, vh) {
    const m = missionOf(view);
    if (m && m.def.overlay) m.def.overlay(ctx, m, view, x0, y0, vw, vh); // 章節自己的天色、天氣（蓋在畫面上，任務標記之下）
    if (m && m.vars.duel) for (const u of m.vars.duelers || []) if (u.alive) postureBar(ctx, u, view.WS.time);
    if (m) for (const u of view.w.units) if (u.chan && u.alive) chanBar(ctx, u);
    if (m) for (const u of view.w.units) if (u.alive && u.asleep && u.sus > 1 && u.vis[view.w.player.team]) susMark(ctx, u); // 還不知情的敵人頭上的疑心
    if (!m || !m.marks.length) return;
    const T = view.WS.time, bob = Math.sin(T * 4) * 6, z = 1 / view.zoom;
    ctx.save();
    ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
    for (const k of m.marks) {
      const s = k.small ? 0.7 : 1;
      if (k.x > x0 && k.x < x0 + vw && k.y > y0 && k.y < y0 + vh) {
        const y = k.y - 120 * s + bob;
        ctx.strokeStyle = `rgba(255,212,107,${0.5 + 0.3 * Math.sin(T * 3)})`; ctx.lineWidth = 3;
        ctx.beginPath(); ctx.ellipse(k.x, k.y, 46 * s, 18 * s, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.fillStyle = '#ffd46b'; ctx.strokeStyle = '#3a2a10'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(k.x, y + 26 * s); ctx.lineTo(k.x - 16 * s, y); ctx.lineTo(k.x + 16 * s, y); ctx.closePath(); ctx.fill(); ctx.stroke();
        if (k.label) { ctx.font = `900 ${Math.round(18 * s)}px "Noto Serif TC", serif`; ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(0,0,0,.75)'; ctx.strokeText(k.label, k.x, y - 4); ctx.fillText(k.label, k.x, y - 4); }
        continue;
      }
      if (k.small) continue;
      // 畫面外：邊緣的箭頭
      const cx = x0 + vw / 2, cy = y0 + vh / 2, dx = k.x - cx, dy = k.y - cy, mx = vw / 2 - 40 * z, my = vh / 2 - 60 * z;
      const f = Math.min(mx / Math.abs(dx || 1e-6), my / Math.abs(dy || 1e-6)), ex = cx + dx * f, ey = cy + dy * f, a = Math.atan2(dy, dx);
      ctx.save(); ctx.translate(ex, ey); ctx.rotate(a); ctx.scale(z, z);
      ctx.fillStyle = '#ffd46b'; ctx.strokeStyle = '#3a2a10'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(18, 0); ctx.lineTo(-10, -13); ctx.lineTo(-10, 13); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.restore();
      if (k.label) { ctx.save(); ctx.translate(ex - Math.cos(a) * 30 * z, ey - Math.sin(a) * 30 * z); ctx.scale(z, z); ctx.font = '900 14px "Noto Serif TC", serif'; ctx.textBaseline = 'middle'; ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(0,0,0,.75)'; ctx.strokeText(k.label, 0, 0); ctx.fillStyle = '#ffd46b'; ctx.fillText(k.label, 0, 0); ctx.restore(); }
    }
    ctx.restore();
  },
  // 小地圖：任務標記、驄馬
  mini(c, view, k) {
    const m = missionOf(view);
    if (!m) return;
    const d = view.dpr, T = view.WS.time;
    c.save(); c.font = `900 ${Math.round(9 * d)}px "Noto Serif TC", serif`; c.textAlign = 'center'; c.textBaseline = 'middle';
    for (const [x, y] of SG.MAP.shops || []) { c.fillStyle = '#e9dcb8'; c.strokeStyle = '#3a2a10'; c.lineWidth = 1; c.fillRect(x * k - 5 * d, y * k - 5 * d, 10 * d, 10 * d); c.strokeRect(x * k - 5 * d, y * k - 5 * d, 10 * d, 10 * d); c.fillStyle = '#7a2a18'; c.fillText('商', x * k, y * k + 0.5 * d); } // 村裡的商舖
    c.restore();
    for (const mk of m.marks) {
      c.fillStyle = '#ffd46b'; c.strokeStyle = '#3a2a10'; c.lineWidth = 1;
      const r = (mk.small ? 2.2 : 3.6 + Math.sin(T * 4)) * d;
      c.beginPath(); c.moveTo(mk.x * k, mk.y * k - r * 1.4); c.lineTo(mk.x * k + r, mk.y * k); c.lineTo(mk.x * k, mk.y * k + r * 1.4); c.lineTo(mk.x * k - r, mk.y * k); c.closePath(); c.fill(); c.stroke();
    }
    const h = m.vars.horse;
    if (h && h.i < h.path.length) { c.fillStyle = '#e8e4d8'; c.beginPath(); c.arc(h.x * k, h.y * k, 2.6 * d, 0, Math.PI * 2); c.fill(); }
  },
};

// ---- 預警、火、讀條、船、城門、鹿角 ----
// 預警：紅色範圍，越接近生效越亮；圓的從中間往外填滿
function warnDraw(ctx, z, T) {
  const k = 1 - Math.max(0, z.t) / z.t0, a = 0.25 + 0.45 * k + 0.1 * Math.sin(T * 18);
  ctx.save();
  ctx.strokeStyle = z.col || '#ff5040'; ctx.fillStyle = z.col || '#ff5040'; ctx.lineWidth = 3;
  if (z.line) {
    ctx.globalAlpha = a * 0.5; ctx.lineCap = 'butt'; ctx.lineWidth = z.w;
    ctx.beginPath(); ctx.moveTo(z.x1, z.y1); ctx.lineTo(z.x2, z.y2); ctx.stroke();
    ctx.globalAlpha = a; ctx.lineWidth = 3; ctx.setLineDash([12, 8]); ctx.stroke(); ctx.setLineDash([]);
  } else {
    ctx.globalAlpha = a * 0.6; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r * k, z.r * k * SG.K, 0, 0, Math.PI * 2); ctx.fill();
    ctx.globalAlpha = a; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r, z.r * SG.K, 0, 0, Math.PI * 2); ctx.stroke();
    if (z.smoke) { ctx.globalAlpha = 0.35 * k; ctx.fillStyle = '#d8d0c0'; for (let i = 0; i < 4; i++) { ctx.beginPath(); ctx.arc(z.x + Math.sin(T * 2 + i * 2) * z.r * 0.4, z.y - 20 - ((T * 30 + i * 20) % 60), 14, 0, Math.PI * 2); ctx.fill(); } }
  }
  ctx.restore();
}
// 火：幾簇跳動的火舌，快燒完時變小
function flame(ctx, c, T) {
  const k = Math.min(1, c.age / 0.8) * Math.min(1, (c.life - c.age) / 2);
  if (k <= 0) return;
  ctx.save(); ctx.translate(c.x, c.y);
  ctx.fillStyle = 'rgba(255,120,40,.18)'; ctx.beginPath(); ctx.ellipse(0, 0, 56, 38, 0, 0, Math.PI * 2); ctx.fill();
  for (let i = 0; i < 3; i++) {
    const ox = (i - 1) * 24 + Math.sin(c.i * 3 + i) * 8, h = (34 + 18 * Math.sin(T * 9 + i * 2 + c.j)) * k;
    ctx.fillStyle = '#e8541c'; ctx.beginPath(); ctx.moveTo(ox - 13 * k, 4); ctx.quadraticCurveTo(ox - 8 * k, -h * 0.6, ox, -h); ctx.quadraticCurveTo(ox + 8 * k, -h * 0.6, ox + 13 * k, 4); ctx.fill();
    ctx.fillStyle = '#ffc040'; ctx.beginPath(); ctx.moveTo(ox - 6 * k, 4); ctx.quadraticCurveTo(ox - 3 * k, -h * 0.35, ox, -h * 0.55); ctx.quadraticCurveTo(ox + 3 * k, -h * 0.35, ox + 6 * k, 4); ctx.fill();
  }
  ctx.restore();
}
// 讀條：頭上一條細條＋要做的事
function chanBar(ctx, u) {
  const c = u.chan, k = 1 - Math.max(0, c.t) / c.t0, w = 90, x = u.x - w / 2, y = u.y - 150;
  ctx.save();
  ctx.fillStyle = 'rgba(0,0,0,.65)'; ctx.fillRect(x - 2, y - 2, w + 4, 10);
  ctx.fillStyle = '#9fd8ff'; ctx.fillRect(x, y, w * k, 6);
  ctx.font = '900 13px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
  ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(0,0,0,.8)'; ctx.strokeText(c.label, u.x, y - 3); ctx.fillStyle = '#d8f0ff'; ctx.fillText(c.label, u.x, y - 3);
  ctx.restore();
}
// 船：木船身、船頭朝行進方向；big 是大船（蒙衝、樓船），fire 是載著柴草的火船
function boatDraw(ctx, b, T) {
  const { poly } = SG.draw, L = b.big ? 150 : b.small ? 70 : 105, H = b.big ? 34 : 22, bob = Math.sin(T * 2 + b.x * 0.01) * 2;
  ctx.save(); ctx.translate(b.x, b.y + 6 + bob); ctx.scale(b.f, 1);
  ctx.fillStyle = 'rgba(200,225,235,.25)'; ctx.beginPath(); ctx.ellipse(-L * 0.2, 6, L * (b.moving ? 1.15 : 0.95), 14, 0, 0, Math.PI * 2); ctx.fill(); // 水波
  poly(ctx, [[-L, -H], [L * 0.75, -H], [L, -H - 10], [L * 0.6, 4], [-L * 0.85, 4]], b.col || '#6e4a2c', 2.2);
  poly(ctx, [[-L + 6, -H], [L * 0.7, -H], [L * 0.7, -H - 6], [-L + 6, -H - 6]], '#8a6038', 1.4);
  if (b.fire) { for (let i = 0; i < 3; i++) poly(ctx, [[-L * 0.6 + i * 34, -H - 6], [-L * 0.6 + i * 34 + 26, -H - 6], [-L * 0.6 + i * 34 + 13, -H - 30]], '#b89a5a', 1.2); } // 柴草
  if (b.burning) { // 火船：整條船都著了
    for (let i = 0; i < 4; i++) {
      const ox = -L * 0.7 + i * L * 0.45, h = 40 + 22 * Math.sin(T * 9 + i * 1.7);
      ctx.fillStyle = '#e8541c'; ctx.beginPath(); ctx.moveTo(ox - 18, -H); ctx.quadraticCurveTo(ox - 10, -H - h * 0.6, ox, -H - h); ctx.quadraticCurveTo(ox + 10, -H - h * 0.6, ox + 18, -H); ctx.fill();
      ctx.fillStyle = '#ffc040'; ctx.beginPath(); ctx.moveTo(ox - 8, -H); ctx.quadraticCurveTo(ox - 4, -H - h * 0.35, ox, -H - h * 0.55); ctx.quadraticCurveTo(ox + 4, -H - h * 0.35, ox + 8, -H); ctx.fill();
    }
  }
  if (b.flag) { ctx.strokeStyle = '#3a2a18'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(-L * 0.2, -H - 6); ctx.lineTo(-L * 0.2, -H - 90); ctx.stroke(); poly(ctx, [[-L * 0.2, -H - 90], [-L * 0.2 + 40, -H - 82 + Math.sin(T * 4) * 3], [-L * 0.2, -H - 66]], b.flag, 1.6); }
  ctx.restore();
}
// 城門：兩扇厚木門、銅釘；被攻破後拿掉（ungate）
function cityGate(ctx, g, T) {
  const { poly } = SG.draw, w = g.r * 0.95;
  ctx.save(); ctx.translate(g.x, g.y + 20);
  poly(ctx, [[-w, 0], [w, 0], [w, -110], [-w, -110]], '#5a3a22', 2.4);
  ctx.strokeStyle = '#3a2416'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(0, -110); ctx.stroke();
  ctx.fillStyle = '#c9a24e'; for (let y = -96; y < -8; y += 22) for (let x = -w + 14; x < w - 6; x += 22) { ctx.beginPath(); ctx.arc(x, y, 2.6, 0, Math.PI * 2); ctx.fill(); }
  if (g.hp != null) { const k = Math.max(0, g.hp / g.hp0); ctx.fillStyle = 'rgba(0,0,0,.6)'; ctx.fillRect(-50, -132, 100, 8); ctx.fillStyle = '#e0b04a'; ctx.fillRect(-49, -131, 98 * k, 6); }
  ctx.restore();
}
// 鹿角：削尖的木樁交叉排開
function abatis(ctx, g, T) {
  ctx.save(); ctx.translate(g.x, g.y);
  ctx.strokeStyle = '#5a3a22'; ctx.lineWidth = 6; ctx.lineCap = 'round';
  const n = Math.max(3, Math.round(g.r / 26));
  for (let i = 0; i < n; i++) { const x = -g.r + (i + 0.5) * (g.r * 2 / n); ctx.beginPath(); ctx.moveTo(x - 18, 6); ctx.lineTo(x + 14, -44); ctx.moveTo(x + 18, 6); ctx.lineTo(x - 14, -44); ctx.stroke(); }
  ctx.strokeStyle = '#3a2416'; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(-g.r, -12); ctx.lineTo(g.r, -12); ctx.stroke();
  ctx.restore();
}
// 躺在地上的傷兵
function lying(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 0, 2, 36, 9, 80, 0.3);
  poly(ctx, [[-30, -4], [22, -4], [22, -16], [-30, -16]], f.cloth || '#7f2a24', 1.8);
  ctx.beginPath(); ctx.arc(30, -12, 9, 0, Math.PI * 2); SG.draw.ink(ctx, '#eec79c', 1.8);
  if (f.talk) { ctx.fillStyle = '#ffd46b'; ctx.font = '900 14px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('…', 30, -30); }
  ctx.restore();
}

// 疑心：頭上的問號，越可疑越紅、越滿
function susMark(ctx, u) {
  const k = Math.min(1, u.sus / 100), x = u.x, y = u.y - 120;
  ctx.save();
  ctx.font = '900 26px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
  ctx.lineWidth = 4; ctx.strokeStyle = 'rgba(0,0,0,.8)'; ctx.strokeText('？', x, y);
  ctx.fillStyle = `rgb(255,${Math.round(220 - 170 * k)},${Math.round(120 - 90 * k)})`; ctx.fillText('？', x, y);
  ctx.fillStyle = 'rgba(0,0,0,.6)'; ctx.fillRect(x - 22, y + 2, 44, 5); ctx.fillStyle = '#ff8a50'; ctx.fillRect(x - 22, y + 2, 44 * k, 5);
  ctx.restore();
}
// 軍需處：一輛堆著箱子與布袋的輜重車，插一面「商」字旗（起點買裝備的地方）
SG.campaignDraw.supply = function (ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 4, 4, 70, 16, 80, 0.3);
  poly(ctx, [[-60, -14], [60, -14], [60, -34], [-60, -34]], '#7a5634', 2);
  for (const x of [-38, 38]) { ctx.beginPath(); ctx.arc(x, -8, 14, 0, Math.PI * 2); SG.draw.ink(ctx, '#4a3424', 2); }
  poly(ctx, [[-52, -34], [-10, -34], [-10, -66], [-52, -66]], '#94704a', 1.6);
  poly(ctx, [[-6, -34], [30, -34], [30, -58], [-6, -58]], '#8a6a44', 1.6);
  ctx.beginPath(); ctx.ellipse(44, -46, 14, 12, 0, 0, Math.PI * 2); SG.draw.ink(ctx, '#c9b07a', 1.6);
  ctx.strokeStyle = '#3a2a18'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(56, -34); ctx.lineTo(56, -112); ctx.stroke();
  poly(ctx, [[56, -110], [88, -110], [88, -78], [56, -78]], '#e9dcb8', 1.6);
  ctx.fillStyle = '#7a2a18'; ctx.font = '900 20px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('商', 72, -87);
  ctx.restore();
};

// 糧倉（圓頂的穀倉，旁邊堆著糧袋）：牛渚的邸閣、烏巢的糧屯都用這個
SG.campaignDraw.granary = function (ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y);
  SG.draw.castShadow(ctx, 8, 4, 90, 20, 90, 0.35);
  poly(ctx, [[-70, 0], [70, 0], [70, -70], [-70, -70]], '#a58a5c', 2.2);
  poly(ctx, [[-86, -66], [86, -66], [50, -120], [-50, -120]], '#5a4630', 2.4);
  poly(ctx, [[-14, 0], [14, 0], [14, -40], [-14, -40]], '#4a3424', 1.8);
  for (const [x, y] of [[-96, 2], [-78, -6], [92, 4]]) { ctx.beginPath(); ctx.ellipse(x, y - 10, 16, 12, 0, 0, Math.PI * 2); SG.draw.ink(ctx, '#c9b07a', 1.6); }
  ctx.fillStyle = '#e9dcb8'; ctx.fillRect(60, -150, 30, 36); ctx.fillStyle = '#7a2a18'; ctx.font = '900 20px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.fillText('糧', 75, -124);
  ctx.restore();
};

// ---- 單挑 ----
// 嶺頂的單挑圈：地上一圈踩出來的土，外緣插著兩家的小旗
function arena(ctx, a, T) {
  ctx.save();
  ctx.fillStyle = 'rgba(120,96,60,.28)'; ctx.beginPath(); ctx.ellipse(a.x, a.y, a.r, a.r * SG.K, 0, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = `rgba(255,214,120,${0.45 + 0.15 * Math.sin(T * 2)})`; ctx.lineWidth = 4; ctx.setLineDash([18, 12]);
  ctx.beginPath(); ctx.ellipse(a.x, a.y, a.r, a.r * SG.K, 0, 0, Math.PI * 2); ctx.stroke(); ctx.setLineDash([]);
  for (let i = 0; i < 8; i++) {
    const t = (i / 8) * Math.PI * 2, x = a.x + Math.cos(t) * (a.r + 14), y = a.y + Math.sin(t) * (a.r + 14) * SG.K, wave = Math.sin(T * 5 + i) * 3;
    ctx.strokeStyle = '#3a2a18'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x, y - 46); ctx.stroke();
    ctx.fillStyle = Math.cos(t) < 0 ? '#b23a2c' : '#5d6a78';
    ctx.beginPath(); ctx.moveTo(x, y - 46); ctx.lineTo(x + 20, y - 40 + wave); ctx.lineTo(x, y - 32); ctx.closePath(); ctx.fill();
  }
  ctx.restore();
}
// 架勢條：頭上一條金色的條；破勢時變紅並閃爍
function postureBar(ctx, u, T) {
  const w = 86, h = 9, x = u.x - w / 2, y = u.y - 158, k = Math.max(0, Math.min(1, u.pos / 100)), br = u.broken > 0;
  ctx.save();
  ctx.fillStyle = 'rgba(0,0,0,.65)'; ctx.fillRect(x - 2, y - 2, w + 4, h + 4);
  ctx.fillStyle = br ? `rgba(230,70,50,${0.5 + 0.5 * Math.sin(T * 14)})` : k < 0.3 ? '#e8833a' : '#ffd46b';
  ctx.fillRect(x, y, br ? w : w * k, h);
  ctx.font = '900 13px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
  ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(0,0,0,.8)';
  const label = br ? '破勢' : '架勢';
  ctx.strokeText(label, u.x, y - 3); ctx.fillStyle = br ? '#ff8a70' : '#ffe9b0'; ctx.fillText(label, u.x, y - 3);
  ctx.restore();
}

// ---- 卡點的樣子 ----
// 橋中段的橋板拆掉了：看得到底下的河水，斷口兩邊散著木板
function brokenBridge(ctx, g, T) {
  ctx.save(); ctx.translate(g.x, g.y); ctx.rotate(g.a); ctx.scale(1, 1);
  ctx.fillStyle = '#2b5163'; ctx.fillRect(-62, -g.w / 2, 124, g.w);
  ctx.strokeStyle = 'rgba(200,225,235,.35)'; ctx.lineWidth = 2;
  for (let i = 0; i < 6; i++) { const y = -g.w / 2 + 16 + i * 30, o = ((T * 30 + i * 17) % 40) - 20; ctx.beginPath(); ctx.moveTo(-40 + o, y); ctx.lineTo(-14 + o, y + 4); ctx.stroke(); }
  ctx.fillStyle = '#4a3424'; ctx.fillRect(-66, -g.w / 2, 8, g.w); ctx.fillRect(58, -g.w / 2, 8, g.w); // 斷口的橫樑
  ctx.fillStyle = '#7a5634'; ctx.strokeStyle = '#3a2618'; ctx.lineWidth = 1.5;
  [[-96, -50, 0.3], [-118, 20, -0.2], [-90, 64, 0.1]].forEach(([x, y, a]) => { ctx.save(); ctx.translate(x, y); ctx.rotate(a + Math.PI / 2); ctx.fillRect(-36, -6, 72, 12); ctx.strokeRect(-36, -6, 72, 12); ctx.restore(); }); // 堆著的新橋板
  ctx.strokeStyle = '#a33'; ctx.lineWidth = 2; ctx.setLineDash([6, 5]); ctx.beginPath(); ctx.moveTo(-74, -78); ctx.lineTo(-74, 78); ctx.moveTo(74, -78); ctx.lineTo(74, 78); ctx.stroke(); ctx.setLineDash([]); // 攔著的繩子
  ctx.restore();
}
// 渡口：水勢湍急，白浪一道道往下游沖
function flood(ctx, g, T) {
  ctx.save();
  ctx.fillStyle = 'rgba(40,80,96,.55)'; ctx.beginPath(); ctx.ellipse(g.x, g.y, 170, 200, 0, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = 'rgba(235,245,250,.55)'; ctx.lineWidth = 3; ctx.lineCap = 'round';
  for (let i = 0; i < 14; i++) {
    const x = g.x - 130 + ((i * 47) % 260), y = g.y - 190 + (((T * 140 + i * 61) % 380));
    ctx.beginPath(); ctx.moveTo(x - 14, y - 10); ctx.quadraticCurveTo(x, y, x + 14, y - 10); ctx.stroke();
  }
  ctx.restore();
}
// 木樁
function pole(ctx, x, y) { SG.draw.caps(ctx, [[[x, y], [x, y - 54], 5, '#5b3d27']]); }
// 告示牌
function sign(ctx, x, y, text) {
  const { poly, caps } = SG.draw, w = text.length * 11 + 16;
  caps(ctx, [[[x, y], [x, y - 66], 4, '#5b3d27']]);
  poly(ctx, [[x - w, y - 92], [x + w, y - 92], [x + w, y - 58], [x - w, y - 58]], '#d8c69a', 2);
  ctx.fillStyle = '#4a2a14'; ctx.font = '900 19px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(text, x, y - 75);
}
// 修橋的工匠：短褐、頭巾，掄著木槌敲橋板
function worker(ctx, x, y, f, T) { person(ctx, x, y, f, T, { tool: 'hammer' }); }
// 村民：衣色、頭巾依人換；走路擺腿，幹活的掄鋤頭，說話時抬手
const LOOKS = [['#8a6a44', '#5a6a7a'], ['#6e7a5a', '#8a3a2a'], ['#7a5a6a', '#d8c8a8'], ['#5a6a7a', '#6a5030']];
function villager(ctx, f, T) {
  const [cloth, band] = LOOKS[f.look], kid = f.name === '村童';
  ctx.save(); ctx.translate(f.x, f.y); if (kid) ctx.scale(0.75, 0.75);
  person(ctx, 0, 0, f.f, T + f.home[0] * 0.01, { cloth, band, tool: f.talk ? 'wave' : f.work, walk: f.walk });
  ctx.restore();
}
function person(ctx, x, y, f, T, o) {
  const { poly, caps } = SG.draw, sw = Math.sin(T * 7);
  ctx.save(); ctx.translate(x, y); ctx.scale(f, 1);
  SG.draw.castShadow(ctx, 0, 2, 18, 6, 60, 0.3);
  const leg = o.walk ? Math.sin(T * 9) * 6 : 0;
  caps(ctx, [[[-5 + leg, 0], [-5, -22], 5, '#4a3a2a'], [[5 - leg, 0], [5, -22], 5, '#4a3a2a']]);
  poly(ctx, [[-11, -20], [11, -20], [9, -48], [-9, -48]], o.cloth || '#8a6a44', 1.8);
  ctx.beginPath(); ctx.arc(0, -58, 9, 0, Math.PI * 2); SG.draw.ink(ctx, '#d8b088', 1.6);
  poly(ctx, [[-9, -62], [9, -62], [8, -68], [-8, -68]], o.band || '#5a6a7a', 1.2);
  if (o.tool === 'hammer' || o.tool === 'hoe') {
    const arm = o.tool === 'hoe' ? -0.9 + Math.max(0, Math.sin(T * 3)) * 1.5 : -1.2 + Math.max(0, sw) * 1.6, len = o.tool === 'hoe' ? 30 : 16;
    const hx = 8 + Math.cos(arm) * 20, hy = -44 + Math.sin(arm) * 20, ex = hx + Math.cos(arm + 1.4) * len, ey = hy + Math.sin(arm + 1.4) * len;
    caps(ctx, [[[6, -44], [hx, hy], 4, '#d8b088'], [[hx, hy], [ex, ey], 3, '#5b3d27']]);
    if (o.tool === 'hoe') caps(ctx, [[[ex, ey], [ex - 9, ey + 4], 4, '#7e8379']]);
    else { ctx.fillStyle = '#6b4a2e'; ctx.beginPath(); ctx.arc(hx + Math.cos(arm + 1.4) * 18, hy + Math.sin(arm + 1.4) * 18, 6, 0, Math.PI * 2); ctx.fill(); }
  } else if (o.tool === 'wave') caps(ctx, [[[6, -44], [16, -62 + Math.sin(T * 5) * 3], 4, '#d8b088']]);
  else caps(ctx, [[[7, -44], [9 + (o.walk ? -leg * 0.6 : 0), -26], 4, '#d8b088']]);
  ctx.restore();
}

// 地上的拾獲物：錢囊、糧袋、竹簡、包袱；上下輕輕浮動，每隔一陣閃一下光
function lootDraw(ctx, l, T) {
  const { poly } = SG.draw, bob = Math.sin(T * 2.4 + l.ph) * 3;
  ctx.save(); ctx.translate(l.x, l.y);
  SG.draw.castShadow(ctx, 0, 2, 20, 6, 60, 0.3);
  ctx.translate(0, -8 + bob);
  const blob = (x, y, rx, ry, c) => { ctx.beginPath(); ctx.ellipse(x, y, rx, ry, 0, 0, Math.PI * 2); SG.draw.ink(ctx, c, 1.8); };
  if (l.kind === 'gold') { blob(0, -10, 15, 13, '#8a5a32'); poly(ctx, [[-6, -22], [6, -22], [4, -28], [-4, -28]], '#6e4426', 1.4); ctx.fillStyle = '#f2c94c'; ctx.beginPath(); ctx.arc(9, -2, 6, 0, Math.PI * 2); ctx.fill(); ctx.beginPath(); ctx.arc(-8, 0, 5, 0, Math.PI * 2); ctx.fill(); }
  else if (l.kind === 'food') { blob(0, -14, 16, 18, '#c8b07a'); ctx.strokeStyle = '#6a5430'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(-8, -28); ctx.lineTo(8, -28); ctx.stroke(); }
  else if (l.kind === 'book') { poly(ctx, [[-18, -4], [18, -4], [18, -18], [-18, -18]], '#c8a860', 1.6); ctx.strokeStyle = 'rgba(80,60,20,.6)'; ctx.lineWidth = 1.5; for (let x = -12; x <= 12; x += 6) { ctx.beginPath(); ctx.moveTo(x, -5); ctx.lineTo(x, -17); ctx.stroke(); } blob(0, -11, 3, 8, '#7a2a18'); }
  else { poly(ctx, [[-17, 0], [17, 0], [17, -20], [-17, -20]], '#7a5634', 1.8); poly(ctx, [[-19, -20], [19, -20], [17, -27], [-17, -27]], '#94704a', 1.6); ctx.fillStyle = '#d9b444'; ctx.fillRect(-3, -16, 6, 7); } // 木箱
  const g = (T * 0.7 + l.ph) % 2.2; // 閃光
  if (g < 0.5) { const a = Math.sin((g / 0.5) * Math.PI), r = 8 + 10 * a; ctx.globalAlpha = a; ctx.fillStyle = '#fff6d0'; ctx.beginPath(); ctx.moveTo(10, -30 - r); ctx.lineTo(12, -32); ctx.lineTo(10 + r, -30); ctx.lineTo(12, -28); ctx.lineTo(10, -30 + r); ctx.lineTo(8, -28); ctx.lineTo(10 - r, -30); ctx.lineTo(8, -32); ctx.closePath(); ctx.fill(); }
  ctx.restore();
}
